import { addDays } from 'date-fns';

export const INITIAL_STATE_USER_AUTHENTICATED = {
  token: 'test-cypress.jwt.token',
  signedRequest: {
    request: {
      method: 'POST',
      path: '/v1/auth',
      body: '',
      timestamp: Date.now(),
      expiration: addDays(Date.now(), 5).getTime(),
    },
    signature: [
      '786497438910000000000000000000000000000000000000000000000000000005908795218',
      '1800110681500000000000000000000000000000000000000000000000000000060383088843',
    ],
  },
  error: null,
  walletSeed: '0x49c8d1111111111111111111b',
  ethereumAddress: '0xC20B28937b11111111111111111111111d605a68',
  rememberMe: false,
};
